module.exports = __webpack_public_path__ + "images/vlabs.18a05728.webp";